import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import * as api from '../../shared/api/apihandler';

export class NotificationFunctions {
  sets;
  showSets: boolean = false;
  constructor(private http: HttpClient){
  }

  getNotificationSets():Observable<any>{
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Website/Case/GetNotificationSets',{headers})
  }

  updateCaseNotificationSet(caseId: string, notificationSetId: string){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.patch(api.jubloApi + 'api/Website/Case/UpdateNotificationSet/'+ caseId + '/' + notificationSetId,{},{headers})
  }

  getById(notificationId:string){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Notification/GetNotifications/' + notificationId, { headers })
  }
}

export class NotificationSets {
  public id: string;
  public companyId: string;
  public title: string;
  public priority: number;
}

export class Notifications {
  public id: string;
  public notificationSetId: string;
  public sortOrder: number;
  public name: string;
  public emailTitle: string;
  public emailTemplate: string;
  public smsTemplate: string;
  public companyEmailTemplate: string;
  public sendSms: boolean;
  public sendEmail: boolean;
  public sendCompanyEmail: boolean;
  public notificationTypeId: string;
  public notificationCategory: Array<NotificationCategory>;
  public delay: number;
  public modifiedBy: string;
  public showInSettings: boolean;
}

export class NotificationCategory {
  public id: string;
  public name: string;
}
